import React from 'react'
import firebase from './../Firestore'
import Producto from './Producto';
import ProductoEmpanada from './ProductoEmpanada';
import ProductoGenerico from './ProductoGenerico';

import store from '../../store';

class SubCategorias extends React.Component {

  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      productos: [],
      productoSeleccionado: "",
      productoSeleccionadoSeFracciona: true,
      esMitad: false,
      idOtraMitad: 0,
      diseno: "pizza"
     };


  }



levantarProductos(categoriaId = this.props.categoriaId){
  var db = firebase.firestore();
  db.collection("producto").where("categoriaID", "==", categoriaId).orderBy("orden", "asc").get().then((snapShots) => {

        this.setState(
          {

            productos: snapShots.docs.map(doc => {
              return {
                "nombre": doc.data().nombre,
                "seFracciona": doc.data().seFracciona,
                "id": doc.id
              }
            })
          }
        );
        if(snapShots.docs.length > 0){
            this.setState({
            productoSeleccionado: snapShots.docs[0].id,
            productoSeleccionadoSeFracciona: snapShots.docs[0].data().seFracciona
            });
            //console.log("snapShots", snapShots.docs[0].id)
        }

  });

}

componentDidMount(){
  this._isMounted = true;
  if (this._isMounted && this.props.categoriaId) {
    this.levantarProductos(this.props.categoriaId)
    //console.log("se ejecuta 3", store.getState().diseno)
    this.setState({
        diseno: store.getState().diseno
    })
  }
}

componentWillUnmount() {
  this._isMounted = false;
}

componentDidUpdate(prevProps){
  this._isMounted = true;
  if (this._isMounted) {
    if (this.props.categoriaId !== prevProps.categoriaId) {
      this.setState({
        esMitad: false,
        idOtraMitad: 0,
        diseno: this.props.diseno
      }
      );
    //  console.log("se ejecuta 2")
      this.levantarProductos()
    }
  }
}

  onChange(event) {
    if(event.target.name === 'subCategoria'){
      let productoId = event.target.value.substring(20, 0);
      let seFracciona = event.target.value.substring(30, 21) === "true" ? true : false
      this.setState({
        productoSeleccionado: productoId,
        productoSeleccionadoSeFracciona: seFracciona
       })
    }else if(event.target.name === 'subCategoria2'){
      this.setState({ idOtraMitad: event.target.value })
    } else if(event.target.name === 'seFracciona'){
        this.setState({ esMitad: event.target.checked })
        if(!event.target.checked) this.setState({ idOtraMitad: 0 })
    }
  }



  render() {

      const Items = this.state.productos.map((todo) =>
      <option key={todo.id} value={todo.id+'-'+todo.seFracciona}>
        {todo.nombre}
      </option>
    );

    let opcionMitad = '';

    if((this.props.seFracciona && this.state.productoSeleccionadoSeFracciona)){
      opcionMitad = (
              <div className="Mitad my-2">
                <div className="custom-control custom-checkbox">
                  <input type="checkbox" onChange={event => this.onChange(event)} className="custom-control-input" id="customCheck1" name="seFracciona" />
                  <label className="custom-control-label float-left mx-2" htmlFor="customCheck1">{this.state.esMitad ? "y la otra Mitad de..." : "Mitad otro sabor?"}</label>
                </div>
              </div>
      )

      var otraMitad = '';
      if(this.props.seFracciona && this.state.esMitad){

        let itemsFraccionables = this.state.productos.filter((item) => item.seFracciona === true && item.id !== this.state.productoSeleccionado);
        let itemsFraccionablesLista = itemsFraccionables.map((todo) =>
          <option key={todo.id} value={todo.id}>
            {todo.nombre}
          </option>
        );

        otraMitad = (

          <div className="d-flex flex-row bd-highlight mb-2">

            {!this.state.idOtraMitad &&
              <i className="far fa-arrow-alt-circle-right fa-3x text-warning"></i>
            }


            <select value={this.state.idOtraMitad} onChange={event => this.onChange(event)} className="custom-select custom-select-lg" name="subCategoria2">
              <option key="0" value="0">Selecciona la otra mitad...</option>
              {itemsFraccionablesLista}
            </select>
        </div>
        )
      }
    }

    const elReturn = (
      <div className="mt-0">
        <div className="py-1 px-2 pt-3 m-0 bg-danger">
           {this.props.seFracciona && this.state.esMitad ? "Una Mitad de..." : ""}
          <div className="d-flex flex-row bd-highlight">

            {!this.state.esMitad &&
              <i className="far fa-arrow-alt-circle-right fa-3x text-warning"></i>
            }

            <select value={this.state.productoSeleccionado+'-'+this.state.productoSeleccionadoSeFracciona} onChange={event => this.onChange(event)} className="custom-select custom-select-lg mb-3" name="subCategoria">
              {Items}
            </select>
          </div>

          {opcionMitad}
          {otraMitad}
        </div>
        <Producto productoId={this.state.productoSeleccionado} producto2Id={this.state.idOtraMitad} uid={this.props.uid} diseno={this.state.diseno}/>
      </div>
    )

    const elReturnEmpa = (
      <div>
        <ProductoEmpanada categoriaId={this.props.categoriaId} uid={this.props.uid} diseno={this.state.diseno}/>
      </div>
    )

    const elReturnGenerico = (
      <div>
        <ProductoGenerico categoriaId={this.props.categoriaId} uid={this.props.uid} diseno={this.state.diseno}/>
      </div>
    )

    var imprimir = "";
    //console.log("this.props.diseno", this.props.diseno)
    if(this.state.diseno === "pizza"){
      imprimir = elReturn
    }else if (this.state.diseno === "empanada") {
      imprimir = elReturnEmpa
    }else if (this.state.diseno === "generico") {
      imprimir = elReturnGenerico
    }
    return imprimir;



  }
}

export default SubCategorias
